import {FormContainer} from 'react-hook-form-mui';
import {List, ListItem} from '@mui/material';
import {FormControlLabel, Checkbox} from '@mui/material';
import {gql} from '@apollo/client';
import {useMutation} from '@apollo/client/react';
import React, {useEffect, useState} from 'react';
import {useRecordContext} from 'components/record/useRecordContext';
import {ControlType, SubEventType} from './ImportSubEventsButton';
import {useDialogContext} from 'components/dialog/DialogContext';
import {useListContext} from 'components/list/ListContext';

const IMPORT_SUBEVENTS = gql`
  mutation ImportSubEvents($slug: String!, $allControls: [ControlPayload!], $subEvents: [ImportSubEventPayload!]) {
    importSubEvents(slug: $slug, allControls: $allControls, subEvents: $subEvents) {
      id
    }
  }
`;

const ImportSubEventBody = (props: {subEvents: SubEventType[]; controls: ControlType[]}) => {
  const {subEvents, controls} = props;
  const {record: event} = useRecordContext();
  const {refetch} = useListContext();
  const {close} = useDialogContext();
  const [selectedSubEvents, setSelectedSubEvents] = useState<{[key: string]: boolean}>({});

  useEffect(() => {
    // Initialize selected state for new subevents
    const initialSelected: {[key: string]: boolean} = {};
    subEvents.forEach((subEvent: {name: string}) => {
      initialSelected[subEvent.name] = false;
    });
    setSelectedSubEvents(initialSelected);
  }, [subEvents]);

  const [importSubEvents] = useMutation<{importSubEvents: {id: number}[]}>(IMPORT_SUBEVENTS);

  const handleSubmit = async () => {
    const selectedSubEventsList = subEvents.filter((subEvent) => selectedSubEvents[subEvent.name]);
    try {
      const result = await importSubEvents({
        variables: {
          slug: event.slug,
          allControls: controls,
          subEvents: selectedSubEventsList
        }
      });
      if (result.data?.importSubEvents) {
        close();
        if (typeof refetch === 'function') {
          refetch();
        }
      }
    } catch {
      // errors surface via Apollo; dialog stays open for retry
    }
  };

  const handleSubEventSelect = (name: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedSubEvents({
      ...selectedSubEvents,
      [name]: event.target.checked
    });
  };

  return (
    <FormContainer onSuccess={handleSubmit} FormProps={{id: 'import_sub_events', noValidate: true}}>
      <List>
        {subEvents.map((subEvent) => (
          <ListItem key={subEvent.name}>
            <FormControlLabel
              control={<Checkbox checked={selectedSubEvents[subEvent.name] || false} onChange={handleSubEventSelect(subEvent.name)} />}
              label={
                <div>
                  <div>
                    <strong>{subEvent.name}</strong>
                  </div>
                  <div style={{fontSize: '0.9em', color: '#666', marginLeft: '24px'}}>
                    Controls: {subEvent.controls.map((control) => control.name).join(' → ')}
                  </div>
                </div>
              }
            />
          </ListItem>
        ))}
      </List>
    </FormContainer>
  );
};

export default ImportSubEventBody;
